import React from 'react';
import { useSelector } from 'react-redux';

import Path from 'routes/Path';
import { Link } from 'components/FormComponents/FormComponents';
import {
  HeaderContentRow,
  UserDetailsContainer,
  UserNameContainer,
  UserName,
  UserCompanyName,
  UserProfileImage,
  UserTestsLeftSpan,
} from './styles';
import { Images } from 'assets/images';
import { userRoles } from 'constants/users';

export default function UserDetails({ userRedirectUrl }) {
  const { user, userRole, company } = useSelector((state) => state.auth);

  const getTagText = () => {
    if (company?.limitless) {
      return 'Unlimited';
    }
    let credits = company?.credits ?? 0;
    let numberOfTests = Math.floor(credits / 100);
    let tagText = 'wat';
    if (numberOfTests === 1) {
      tagText = numberOfTests + ' test';
    } else if (numberOfTests >= 1) {
      tagText = numberOfTests + ' tests';
    } else {
      tagText = '0 tests left! Click here to buy more';
    }
    return tagText;
  };

  const getUserDetails = () => (
    <HeaderContentRow>
      <UserDetailsContainer>
        {userRole !== userRoles.CANDIDATE && company && (
          <UserTestsLeftSpan>
            <Link to={Path.payments}>{getTagText()}</Link>
          </UserTestsLeftSpan>
        )}
        <a href={userRedirectUrl}>
          <UserNameContainer>
            <UserName>{user.name || user.coderCommunityProfile?.name}</UserName>
            {company?.name && <UserCompanyName>{company.name}</UserCompanyName>}
          </UserNameContainer>
        </a>
        <a href={userRedirectUrl}>
          <UserProfileImage
            src={user.avatar?.search('/images') !== 0 ? user.avatar : Images.defaultAvatar}
            alt="profile pic"
          />
        </a>
      </UserDetailsContainer>
    </HeaderContentRow>
  );

  return userRole ? getUserDetails() : null;
}
